module.exports = __webpack_public_path__ + "static/media/CloudG.5348aa14.png";